/**
 * Placeholder module that is null in the codebase but can be overridden by RequireJS mappings
 *
 * to suit the needs of a particular runtime environment.
 *
 * Principally used for loading different fixtures into our mock server during development.
 *
 * @see 'bundles/naptimejs/util/initialRehydration' in config/serve/sample.js
 */
export default null;
